import mitt from "mitt";
import Utils from "./utils";

const $ = window.jQuery;

export default class Store {
    constructor() {
        this.data = new Map();
        this.url = Utils.addTrailingSlash(
            window.location.origin + window.location.pathname,
        );
        this.lastUrl = this.url;
        this.navigationDirection = "forward";
        this.loadPage(this.url, { silent: true });

        const { on, emit } = mitt();
        this.on = on;
        this.trigger = emit;

        this.scrollTop = 0;
    }

    set(url, data) {
        this.data.set(url, data);
        this.cleanup();

        return true;
    }

    get(url) {
        var cachedPage = this.data.get(url);
        if (typeof cachedPage === "undefined") {
            cachedPage = false;
        }
        return cachedPage;
    }

    cleanup() {
        var maxCacheEntries = 10;
        var index = 0;
        var mapSize = this.data.size;
        this.data.forEach(function (value, key, map) {
            index++;
            if (mapSize - index > maxCacheEntries - 1) {
                map.delete(key);
            }
        });
    }

    updateFragment(url, key, value) {
        if (typeof this.data.get(url) === "undefined") {
            // console.warn(`Failed to update data for ${url}: It does not exist.`);
            return;
        }
        var tmp = this.data.get(url);
        tmp[key] = value;
        this.data.set(url, tmp);
    }

    loadPage(url, options) {
        this.lastUrl = this.url;
        this.url = url;

        var options = $.extend(
            {
                silent: false,
                useCache: true,
                loadedEventName: "pageLoaded",
            },
            options,
        );

        var cachedData = this.get(this.url);

        if (options.useCache && cachedData) {
            this.trigger(options.loadedEventName, {
                source: "cache",
                data: cachedData,
            });

            return;
        }

        let self = this;
        function handleResponse(data) {
            data["scrollTop"] = -1;
            self.set(url, data);
            if (!options.silent) {
                self.trigger(options.loadedEventName, {
                    source: "server",
                    data: data,
                });
            }
        }

        $.ajax({
            method: "get",
            url: url,
            cache: false,
            headers: { "x-rah-request-type": "json" },
        })
            .fail((response) => {
                handleResponse(response.responseJSON);
            })
            .then((loadedData) => {
                handleResponse(loadedData);
            });
    }

    isHashLink(url) {
        return url.indexOf("#") !== -1;
    }

    getEntryIndex(url) {
        var keys = this.data.keys();
        var index = 0;
        for (let key of keys) {
            if (key === url) {
                return index;
            }
            index++;
        }
        return -1;
    }

    detectNavigationDirection() {
        var lastEntryIndex = this.getEntryIndex(this.lastUrl);
        var currentEntryIndex = this.getEntryIndex(this.url);
        this.navigationDirection =
            currentEntryIndex <= lastEntryIndex ? "barkward" : "forward";
    }
}
